<div class="row g-0 services-nav-card">
  <!-- Close button -->
  <button type="button" class="btn-close position-absolute m-3" aria-label="Close" (click)="closeCard()">
  </button>

  <!-- Left Side - Header Text -->
  <div class="col-md-3 p-4 services-nav-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Our Products, Built On Eight Years Of Enterprise Delivery</h2>
    <p class="text-gray small mb-0">
      Nine proprietary AI products engineered in-house at Kalpita Technologies — from sovereign enterprise AI and
      offline data protection to autonomous DevOps and AI-native hiring. Each one is production-proven, deployable in
      your environment, and built to keep your data yours.
    </p>
  </div>

  <!-- Right Side - Grid -->
  <div class="col-md-9 p-4 bg-white">
    <div class="row">

      <!-- Column 1: Enterprise AI & Data + Hiring & Talent -->
      <div class="col-12 col-md-6">
        <ng-container *ngFor="let group of groups.slice(0, 2)">
          <div class="text-left mb-3">
            <h5 class="fw-bold text-dark">{{ group.heading }}</h5>
          </div>
          <ul class="list-unstyled mb-4">
            <li *ngFor="let item of group.items">
              <a [routerLink]="item.route" class="dropdown-item" (click)="closeCard()">
                <span class="solution-name">{{ item.name }}</span>
                <span class="solution-descriptor">{{ item.descriptor }}</span>
              </a>
            </li>
          </ul>
        </ng-container>
      </div>

      <!-- Column 2: Engineering & DevOps + Industry Solutions -->
      <div class="col-12 col-md-6">
        <ng-container *ngFor="let group of groups.slice(2)">
          <div class="text-left mb-3">
            <h5 class="fw-bold text-dark">{{ group.heading }}</h5>
          </div>
          <ul class="list-unstyled mb-4">
            <li *ngFor="let item of group.items">
              <a [routerLink]="item.route" class="dropdown-item" (click)="closeCard()">
                <span class="solution-name">{{ item.name }}</span>
                <span class="solution-descriptor">{{ item.descriptor }}</span>
              </a>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
</div>
